"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleList = function VehicleList() {
  return _react2.default.createElement(
    "g",
    { id: "icon_vehicle_list" },
    _react2.default.createElement("path", {
      d: "M466.7,131.3 L33.3,131.3 C13.3,131.3 0,119.4 0,101.7 C0,84 13.3,72 33.3,72 L466.6,72 C486.6,72 499.9,83.9 499.9,101.6 C499.9,119.3 486.7,131.3 466.7,131.3 Z M366.7,279.4 L33.3,279.4 C13.3,279.4 0,267.5 0,249.8 C0,232 13.3,220.2 33.3,220.2 L366.6,220.2 C386.6,220.2 399.9,232 399.9,249.8 C400,267.6 386.7,279.4 366.7,279.4 Z M466.7,427.6 L33.3,427.6 C13.3,427.6 0,415.7 0,398 C0,380.2 13.3,368.4 33.3,368.4 L466.6,368.4 C486.6,368.4 499.9,380.2 499.9,398 C500,415.7 486.7,427.6 466.7,427.6 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = VehicleList;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/VehicleList.js
// module id = 3007
// module chunks = 4